export const configDeviceList = {
    default: 'default',
    devices: [
        {
            id: 'default',
            name: 'Desktop (2xl)',
            width: '',
            priority: 0,
        },
        {
            id: '2xl',
            name: 'Laptop (xl)',
            width: '1535px',
            widthMedia: '1536px',
            priority: 1,
        },
        {
            id: 'xl',
            name: 'Tablet Landscape (lg)',
            width: '1279px',
            widthMedia: '1280px',
            priority: 2,
        },
        {
            id: 'lg',
            name: 'Tablet (md)',
            width: '1023px',
            widthMedia: '1024px',
            priority: 3,
        },
        {
            id: 'md',
            name: 'Mobile Landscape (sm)',
            width: '767px',
            widthMedia: '768px',
            priority: 4,
        },
        {
            id: 'sm',
            name: 'Mobile (xs)',
            width: '639px',
            widthMedia: '640px',
            priority: 5,
        },
    ],
};

export const getDeviceCommandId = (deviceId) => `set-device-${deviceId}`;

export const getSortedDevices = () =>
    [...configDeviceList.devices].sort((a, b) => a.priority - b.priority);

export const getDeviceSelectOptionsHtml = () =>
    getSortedDevices()
        .map(
            (device) =>
                `<option value="${device.id}"${
                    device.id === configDeviceList.default ? ' selected' : ''
                }>${device.name}</option>`
        )
        .join('');
